<template v-if="value !== null && value !== undefined">
  <div class="info-slider-row">
    <div class="info-slider-label">{{ title }}</div>
    <div class="info-slider-container">
        <input type="range" :min="min" :max="max" :step="step" 
          :value="value" class="info-slider"
          @change="handleChange" @keydown="keydownHandler"
          >
    </div>
    <input class="info-opacity-input" type="number" :value="value" 
           @change="handleChange" @keydown="keydownHandler" />
  </div>
</template>

<script>
import { useContentStore } from "@/stores/content";

export default {
  props:{
    value: {
      type: Number,
      required: true
    },
    title:{
      type:String,
      default(){
        return "";
      }
    },
    min:{
      type:Number, default(){return 0;}
    },
    max:{
      type:Number, default(){return 100;}
    },
    step:{
      type:Number, default(){return 1;}
    },
  },

  setup(){
    const contentStore = useContentStore();
    return {contentStore};
  },

  methods: {

    keydownHandler(event){
      
      event.stopPropagation();
    },


    handleChange(event) {
      const newValue = parseFloat(event.target.value);
      this.$emit('change', newValue);
    }


  }
}
</script>